"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6662],{

/***/ 34435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ ArticleCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86492);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(he__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15861);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91036);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56721);
/* harmony import */ var _components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19147);
/* harmony import */ var _utils_dateMonthYearFormat__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42182);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);










var ArticleCard = function(param) {
    var imageUrl = param.imageUrl, title = param.title, url = param.url, description = param.description, articleCreateDate = param.articleCreateDate, _slotProps = param.slotProps, slotProps = _slotProps === void 0 ? {} : _slotProps;
    var isCareTheme = (0,_care_react_component_lib__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isCareTheme;
    var ref = (0,_components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_4__/* .useResponsive */ .F)(), isSmallViewport = ref.isSmallViewport, isLargeViewport = ref.isLargeViewport;
    // remove the <p> tag from the description
    var previewDescription = description ? "".concat(description.replace(/<\/?p>/gi, ""), "...") : null;
    var articleDate = articleCreateDate !== null ? (0,_utils_dateMonthYearFormat__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        dateTime: articleCreateDate,
        useOrdinalDay: false,
        useLongMonth: true,
        useFullDate: true
    }) : null;
    var amplitudeEventCardClick = function() {
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, {
            feature_name: "Clicked Article Carousel"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.link), {
            onClick: amplitudeEventCardClick,
            href: url,
            target: !isSmallViewport ? "_blank" : "_self",
            variant: "link2",
            sx: function(theme) {
                var ref;
                return {
                    color: theme.palette.text.primary,
                    textDecoration: "none",
                    WebkitTapHighlightColor: "transparent",
                    "&:hover": {
                        color: isCareTheme ? (ref = theme.palette.care.navy) === null || ref === void 0 ? void 0 : ref[700] : undefined,
                        cursor: "pointer",
                        textDecoration: "none"
                    }
                };
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.image), {
                    mb: {
                        xs: 1,
                        sm: 2
                    },
                    borderRadius: "24px",
                    component: "img",
                    src: imageUrl,
                    alt: title,
                    loading: "lazy"
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    display: "flex",
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.title), {
                            component: "h3",
                            variant: "h3",
                            mb: 1,
                            children: he__WEBPACK_IMPORTED_MODULE_1___default().decode(title)
                        })),
                        previewDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.description), {
                            component: "p",
                            variant: isLargeViewport ? "body2" : "body3",
                            color: "text.secondary",
                            dangerouslySetInnerHTML: {
                                __html: sanitize_html__WEBPACK_IMPORTED_MODULE_11___default()(he__WEBPACK_IMPORTED_MODULE_1___default().decode(articleDate ? "".concat(articleDate, " - ").concat(previewDescription) : previewDescription))
                            }
                        }))
                    ]
                })
            ]
        }))
    });
};


/***/ }),

/***/ 83845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ArticleSection": function() { return /* binding */ ArticleSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46574);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73739);
/* harmony import */ var _components_common_Carousel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35129);
/* harmony import */ var _components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19147);
/* harmony import */ var _components_common_ArticleSection_ArticleCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34435);






var ArticleSection = function(param) {
    var articles = param.articles;
    var isSmallViewport = (0,_components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_4__/* .useResponsive */ .F)().isSmallViewport;
    var segmentNameSingular = (0,_components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_1__/* .usePageAttributes */ .l)().segmentNameSingular;
    if (articles.length <= 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        disableGutters: true,
        maxWidth: "lg",
        sx: {
            px: {
                xs: 3
            },
            pt: {
                xs: 4,
                sm: 0
            },
            mb: {
                xs: 6,
                md: 12
            },
            mt: {
                sm: 6,
                md: 12
            },
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                component: "h2",
                variant: isSmallViewport ? "h1" : "display3",
                mb: {
                    xs: 4,
                    sm: 6
                },
                mt: 0,
                children: segmentNameSingular ? "".concat(segmentNameSingular, " Articles") : "Related articles"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Carousel__WEBPACK_IMPORTED_MODULE_2__/* .Carousel */ .l, {
                controlVariant: isSmallViewport ? "none" : "topRight",
                showProgressIndicator: isSmallViewport,
                itemsPerView: isSmallViewport ? 1 : 3,
                children: articles.map(function(article) {
                    var ref;
                    if (!((ref = article.largeImage) === null || ref === void 0 ? void 0 : ref.imageUrl)) return null;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_ArticleSection_ArticleCard__WEBPACK_IMPORTED_MODULE_3__/* .ArticleCard */ .T, {
                        url: article.url,
                        imageUrl: article.largeImage.imageUrl,
                        title: article.title,
                        description: article.description,
                        articleCreateDate: article.createDate
                    }, article.title);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ArticleSection);


/***/ }),

/***/ 85665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ Illustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationSmallChildCare.js
var IllustrationSmallChildCare = __webpack_require__(4867);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationMediumChildCare.js
var IllustrationMediumChildCare = __webpack_require__(93365);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationSmallSeniorCare.js
var IllustrationSmallSeniorCare = __webpack_require__(73807);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationMediumSeniorCare.js
var IllustrationMediumSeniorCare = __webpack_require__(8998);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationSmallAdultCare.js
var IllustrationSmallAdultCare = __webpack_require__(12730);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationMediumAdultCare.js
var IllustrationMediumAdultCare = __webpack_require__(20043);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationSmallPetCare.js
var IllustrationSmallPetCare = __webpack_require__(57240);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationMediumPetCare.js
var IllustrationMediumPetCare = __webpack_require__(55610);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationSmallHousekeeping.js
var IllustrationSmallHousekeeping = __webpack_require__(16416);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationMediumHousekeeping.js
var IllustrationMediumHousekeeping = __webpack_require__(6662);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationSmallTutoring.js
var IllustrationSmallTutoring = __webpack_require__(97620);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationMediumTutoring.js
var IllustrationMediumTutoring = __webpack_require__(38358);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationSmallDayCare.js
var IllustrationSmallDayCare = __webpack_require__(12090);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/IllustrationMediumDayCare.js
var IllustrationMediumDayCare = __webpack_require__(48308);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/getSideIllustration.tsx




/**
 * Returns the side illustration based on the provided SEO segment ID and service ID.
 * @param {Object} params - The parameters object.
 * @param {string} params.seoSegmentId - The SEO segment ID.
 * @param {string} params.serviceId - The service ID.
 * @returns {Record<string, JSX.Element> | null} - A record of JSX elements representing the side illustrations, or null if no matching illustrations are found.
 */ var getSideIllustration = function(param) {
    var seoSegmentId = param.seoSegmentId, serviceId = param.serviceId;
    var segmentId = "/".concat(seoSegmentId.split("/")[1]);
    var childCareIllustrations = Object.freeze({
        small: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationSmallChildCare/* default */.Z, {}),
        medium: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationMediumChildCare/* default */.Z, {})
    });
    var seniorCareIllustrations = Object.freeze({
        small: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationSmallSeniorCare/* default */.Z, {}),
        medium: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationMediumSeniorCare/* default */.Z, {})
    });
    var adultCareIllustrations = Object.freeze({
        small: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationSmallAdultCare/* default */.Z, {}),
        medium: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationMediumAdultCare/* default */.Z, {})
    });
    var petCareIllustrations = Object.freeze({
        small: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationSmallPetCare/* default */.Z, {}),
        medium: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationMediumPetCare/* default */.Z, {})
    });
    var housekeepingIllustrations = Object.freeze({
        small: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationSmallHousekeeping/* default */.Z, {}),
        medium: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationMediumHousekeeping/* default */.Z, {})
    });
    var tutoringIllustrations = Object.freeze({
        small: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationSmallTutoring/* default */.Z, {}),
        medium: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationMediumTutoring/* default */.Z, {})
    });
    var dayCareIllustrations = Object.freeze({
        small: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationSmallDayCare/* default */.Z, {}),
        medium: /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustrationMediumDayCare/* default */.Z, {})
    });
    var _obj;
    var sideIllustrationMapForVerticals = Object.freeze((_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* ServiceId.CHILDCARE */.Xs.CHILDCARE, childCareIllustrations), (0,_define_property/* default */.Z)(_obj, constants/* ServiceId.SENIRCARE */.Xs.SENIRCARE, seniorCareIllustrations), (0,_define_property/* default */.Z)(_obj, constants/* ServiceId.PETCAREXX */.Xs.PETCAREXX, petCareIllustrations), (0,_define_property/* default */.Z)(_obj, constants/* ServiceId.HOUSEKEEP */.Xs.HOUSEKEEP, housekeepingIllustrations), (0,_define_property/* default */.Z)(_obj, constants/* ServiceId.TUTORINGX */.Xs.TUTORINGX, tutoringIllustrations), _obj));
    var sideIllustrationMapForSegmentIDs = Object.freeze({
        "/adult-care": adultCareIllustrations,
        "/day-care": dayCareIllustrations
    });
    var _segmentId, ref;
    return (ref = (_segmentId = sideIllustrationMapForSegmentIDs[segmentId]) !== null && _segmentId !== void 0 ? _segmentId : sideIllustrationMapForVerticals[serviceId]) !== null && ref !== void 0 ? ref : null;
};

// EXTERNAL MODULE: ./src/components/contexts/PageAttributesContext.tsx
var PageAttributesContext = __webpack_require__(73739);
;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/Illustration.tsx





var Illustration = function(param) {
    var sx = param.sx;
    var ref = (0,PageAttributesContext/* usePageAttributes */.l)(), seoSegmentId = ref.seoSegmentId, serviceId = ref.serviceId;
    var isMediumOrLargeViewport = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.between("md", "xl");
    });
    var isLargestViewport = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("xl");
    });
    var sideIllustration = getSideIllustration({
        seoSegmentId: seoSegmentId,
        serviceId: serviceId
    });
    if (!sideIllustration) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: (0,_to_consumable_array/* default */.Z)(Array.isArray(sx) ? sx : [
            sx
        ]),
        children: [
            isMediumOrLargeViewport && sideIllustration.small,
            isLargestViewport && sideIllustration.medium
        ]
    });
};


/***/ }),

/***/ 49366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ ProductSchema; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73739);


var ProductSchema = function(param) {
    var avgReviewRating = param.avgReviewRating, totalReviewCount = param.totalReviewCount;
    var segmentNamePluralLowerCase = (0,_components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_1__/* .usePageAttributes */ .l)().segmentNamePluralLowerCase;
    var nameTitle = segmentNamePluralLowerCase.charAt(0).toUpperCase() + segmentNamePluralLowerCase.slice(1);
    var ProductSchemaList = function() {
        var roundAvgReviewRating = avgReviewRating.toFixed(1);
        var product = {
            "@context": "https://schema.org",
            "@type": "Product",
            name: nameTitle,
            brand: {
                "@type": "Organization",
                name: "Care.com"
            },
            aggregateRating: {
                "@type": "AggregateRating",
                ratingValue: roundAvgReviewRating,
                reviewCount: "".concat(totalReviewCount),
                bestRating: "5",
                worstRating: "1"
            }
        };
        return product;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
        "data-testid": "productSchema",
        type: "application/ld+json",
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(ProductSchemaList())
        }
    });
};


/***/ }),

/***/ 3092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ ReviewsSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js
var Container = __webpack_require__(46574);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ./node_modules/he/he.js
var he = __webpack_require__(86492);
var he_default = /*#__PURE__*/__webpack_require__.n(he);
// EXTERNAL MODULE: ./src/components/common/Carousel.tsx
var Carousel = __webpack_require__(35129);
// EXTERNAL MODULE: ./src/context/searchDirectory/SearchDirectoryDataContext.tsx
var SearchDirectoryDataContext = __webpack_require__(32826);
// EXTERNAL MODULE: ./src/components/hooks/useResponsive.tsx
var useResponsive = __webpack_require__(19147);
// EXTERNAL MODULE: ./src/components/contexts/PageAttributesContext.tsx
var PageAttributesContext = __webpack_require__(73739);
// EXTERNAL MODULE: ./src/__generated__/globalTypes.ts
var globalTypes = __webpack_require__(79967);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Box/Box.js + 1 modules
var Box_Box = __webpack_require__(89609);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Rating/Rating.js + 6 modules
var Rating = __webpack_require__(25628);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./src/components/common/ReadMore.tsx
var ReadMore = __webpack_require__(33424);
;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/ReviewsSection/ReviewCard.tsx





var ReviewCard = function(param) {
    var revieweeName = param.revieweeName, comment = param.comment, rating = param.rating, reviewerName = param.reviewerName;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        sx: {
            border: "none",
            minHeight: {
                sm: "375px",
                md: "250px"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
            sx: {
                "&.MuiCardContent-root": {
                    p: 3
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h3",
                    mb: 1,
                    children: revieweeName
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                    defaultValue: rating,
                    readOnly: true,
                    sx: {
                        mb: 2
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                    mb: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore/* ReadMore */.y, {
                        component: "div",
                        showLessLabel: "read less",
                        showMoreLabel: "read more",
                        charLimit: 140,
                        value: comment,
                        variant: "body2"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body3",
                    textAlign: "right",
                    sx: {
                        color: "text.secondary"
                    },
                    children: "- ".concat(reviewerName)
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/ReviewsSection/useSearchResultReviews.tsx



var useSearchResultReviews = function(seoSegmentationSearchResults, searchDirectoryTemplateType) {
    var maxNumberOfReviewsToDisplay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    var caregiverSearchResults = seoSegmentationSearchResults.caregiverSearchResults, providerSearchResults = seoSegmentationSearchResults.providerSearchResults;
    var filterProfilesWithReviews = function(profiles) {
        return profiles.filter(function(profile) {
            return profile.latestReview && profile.latestReview.comment && profile.latestReview.rating;
        }).map(function(profile) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, profile), {
                latestReview: profile.latestReview
            });
        });
    };
    var mapCaregiverReviewCardProps = function(profiles) {
        return profiles.map(function(param) {
            var _latestReview = param.latestReview, reviewer = _latestReview.reviewer, comment = _latestReview.comment, rating = _latestReview.rating, caregiver = param.caregiver;
            return {
                revieweeName: caregiver.member.displayName,
                reviewerName: reviewer.displayName !== "" ? reviewer.displayName : "Care member",
                comment: comment,
                rating: rating
            };
        });
    };
    var mapProviderReviewCardProps = function(profiles) {
        return profiles.map(function(param) {
            var _latestReview = param.latestReview, reviewer = _latestReview.reviewer, comment = _latestReview.comment, rating = _latestReview.rating, seoSegmentationProvider = param.seoSegmentationProvider;
            return {
                revieweeName: seoSegmentationProvider.provider.name,
                reviewerName: reviewer.displayName !== "" ? reviewer.displayName : "Care member",
                comment: comment,
                rating: rating
            };
        });
    };
    if (searchDirectoryTemplateType === "CAREGIVER") {
        var caregiverProfiles = filterProfilesWithReviews(caregiverSearchResults);
        if (caregiverProfiles.length < 3) return null;
        return mapCaregiverReviewCardProps(caregiverProfiles).slice(0, maxNumberOfReviewsToDisplay);
    }
    if (searchDirectoryTemplateType === "SMB") {
        var providerProfiles = filterProfilesWithReviews(providerSearchResults);
        if (providerProfiles.length < 3) return null;
        return mapProviderReviewCardProps(providerProfiles).slice(0, maxNumberOfReviewsToDisplay);
    }
    if (searchDirectoryTemplateType === "HYBRID") {
        var caregiverProfiles1 = filterProfilesWithReviews(caregiverSearchResults);
        var providerProfiles1 = filterProfilesWithReviews(providerSearchResults);
        if (caregiverProfiles1.length + providerProfiles1.length < 3) {
            return null;
        }
        return (0,_to_consumable_array/* default */.Z)(mapCaregiverReviewCardProps(caregiverProfiles1)).concat((0,_to_consumable_array/* default */.Z)(mapProviderReviewCardProps(providerProfiles1))).slice(0, maxNumberOfReviewsToDisplay);
    }
    return null;
};

;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/ReviewsSection/ReviewsSection.tsx













var ReviewsSection = function(param) {
    var searchDirectoryTemplateType = param.searchDirectoryTemplateType, slotProps = param.slotProps;
    var ref, ref1, ref2, ref3;
    var pageData = (0,SearchDirectoryDataContext/* useSearchDirectoryData */.Q)();
    var seoSegmentationSearchResults = pageData.seoSegmentationSearchResults;
    var segmentationStats = ((ref = pageData.seoSegmentationStats) === null || ref === void 0 ? void 0 : ref.__typename) === "SEOSegmentationStatsSuccess" ? pageData.seoSegmentationStats.caregiverStats : null;
    var isSmallViewport = (0,useResponsive/* useResponsive */.F)().isSmallViewport;
    var ref4 = (0,PageAttributesContext/* usePageAttributes */.l)(), segmentNameSingularLowerCase = ref4.segmentNameSingularLowerCase, segmentNamePluralLowerCase = ref4.segmentNamePluralLowerCase, segmentNamePlural = ref4.segmentNamePlural, city = ref4.city, state = ref4.state, pageType = ref4.pageType;
    var reviewsList = useSearchResultReviews(seoSegmentationSearchResults, searchDirectoryTemplateType);
    var ref5;
    var avgReviewRating = (ref5 = segmentationStats === null || segmentationStats === void 0 ? void 0 : (ref1 = segmentationStats.avgReviewRating) === null || ref1 === void 0 ? void 0 : ref1.toFixed(1)) !== null && ref5 !== void 0 ? ref5 : "";
    var ref6;
    var totalReviews = (ref6 = segmentationStats === null || segmentationStats === void 0 ? void 0 : (ref2 = segmentationStats.totalReviewCount) === null || ref2 === void 0 ? void 0 : ref2.toLocaleString()) !== null && ref6 !== void 0 ? ref6 : "";
    var ref7;
    var totalProviders = (ref7 = segmentationStats === null || segmentationStats === void 0 ? void 0 : (ref3 = segmentationStats.totalProviders) === null || ref3 === void 0 ? void 0 : ref3.toLocaleString()) !== null && ref7 !== void 0 ? ref7 : "";
    var showSubheadline = avgReviewRating.length > 0 && totalReviews.length > 0 && totalProviders.length > 0;
    var headline = function() {
        if (pageType === globalTypes/* SEOSegmentationPageType.LOCAL */.a6.LOCAL) {
            return "Recent ".concat(segmentNameSingularLowerCase, " reviews from local parents in ").concat(city, ",&nbsp;").concat(state);
        }
        return "Recent ".concat(segmentNameSingularLowerCase, " reviews from local parents");
    }();
    var subheadline = function() {
        if (pageType === globalTypes/* SEOSegmentationPageType.LOCAL */.a6.LOCAL) {
            return "".concat(segmentNamePlural, " in ").concat(city, ",&nbsp;").concat(state, " are rated ").concat(avgReviewRating, " out of 5 stars based on ").concat(totalReviews, " reviews of the ").concat(totalProviders, " listed ").concat(segmentNamePluralLowerCase);
        }
        return "".concat(segmentNamePlural, " are rated ").concat(avgReviewRating, " out of 5 stars based on ").concat(totalReviews, " reviews of the ").concat(totalProviders, " listed ").concat(segmentNamePluralLowerCase);
    }();
    if (!reviewsList || reviewsList.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            bgcolor: "background.accent.accent1"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            maxWidth: "lg",
            sx: {
                py: {
                    xs: 6,
                    sm: 8
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.headline), {
                    component: "h2",
                    variant: isSmallViewport ? "h1" : "display3",
                    sx: {
                        mt: 0,
                        mb: {
                            xs: 3,
                            sm: 2
                        }
                    },
                    dangerouslySetInnerHTML: {
                        __html: sanitize_html_default()(he_default().decode(headline))
                    }
                })),
                showSubheadline && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.subheadline), {
                    component: "p",
                    variant: "body2",
                    sx: {
                        mb: {
                            xs: 3,
                            sm: 6
                        },
                        maxWidth: {
                            sm: "80%"
                        }
                    },
                    dangerouslySetInnerHTML: {
                        __html: sanitize_html_default()(he_default().decode(subheadline))
                    }
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
                    showProgressIndicator: isSmallViewport,
                    itemsPerView: isSmallViewport ? 1 : 3,
                    controlVariant: isSmallViewport ? "none" : "topRight",
                    children: reviewsList.map(function(param) {
                        var revieweeName = param.revieweeName, reviewerName = param.reviewerName, comment = param.comment, rating = param.rating;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewCard, {
                            revieweeName: revieweeName,
                            reviewerName: reviewerName,
                            comment: comment,
                            rating: rating
                        }, "".concat(revieweeName, "-").concat(reviewerName));
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 73006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ getArticlesList; }
/* harmony export */ });
/**
 * @JSDOC
 * This function extracts the articles data from the SEOArticlesList object.
 * It checks if the SEOArticlesList is of type 'SEOArticlesListSuccess' and returns the articles.
 * If the type is not 'SEOArticlesListSuccess', it returns an empty array.
 * @param {seoSegmentationListingPage['seoArticlesList']} seoArticlesList - The SEOArticlesList object.
 * @returns {seoSegmentationListingPage['seoArticlesList']['articles']} - The articles data or an empty array.
 * @example
 * const articles = getArticlesList(seoArticlesList);
 * // articles will be of type seoSegmentationListingPage['seoArticlesList']['articles']
 * // If seoArticlesList is of type 'SEOArticlesListSuccess', it will contain the articles.
 * // If not, it will be an empty array.
 */ var getArticlesList = function(seoArticlesList) {
    if (seoArticlesList.__typename === "SEOArticlesListSuccess") {
        var ref;
        var ref1;
        return (ref1 = (ref = seoArticlesList.seoArticlesList) === null || ref === void 0 ? void 0 : ref.articles) !== null && ref1 !== void 0 ? ref1 : [];
    }
    return [];
};


/***/ }),

/***/ 21444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ narrowSegmentationStats; }
/* harmony export */ });
var narrowSegmentationStats = function(seoSegmentationStats) {
    return (seoSegmentationStats === null || seoSegmentationStats === void 0 ? void 0 : seoSegmentationStats.__typename) === "SEOSegmentationStatsSuccess" ? seoSegmentationStats.caregiverStats : null;
};


/***/ })

}]);